import { gsap } from 'gsap'

document.addEventListener('alpine:init', () => {
  Alpine.data('accordion', () => ({
    open: false,
    toggle() {
      const content = this.$refs.content;

      if (this.open) {
        gsap.to(content, {
          height: 0,
          duration: 0.35,
          ease: 'power2.inOut'
        });
      } else {
        content.style.height = 'auto';
        const fullHeight = content.scrollHeight;
        content.style.height = '0px';

        gsap.to(content, {
          height: fullHeight,
          duration: 0.35,
          ease: 'power2.inOut',
          onComplete: () => {
            content.style.height = 'auto';
          }
        });
      }

      this.open = !this.open;
    },
    init() {
      this.$refs.content.style.height = '0px';
    }
  }));
});